import styles from "./RightPanelToggleButton.module.scss";
import { RightPanelToggleIcon } from "../../../../../../assets/icons/RightPanelToggleIcon";
import { useDataPageRightPanelContext } from "../../../../../providers/DataPageRightPanelProvider";
import classNames from "classnames";
import { useClearLabelPropagationSearchParams } from "../../../../../../hooks/LabelPropagation/useClearLabelPropagationSearchParams";

export const RightPanelToggleButton = ({
  className,
}: {
  className?: string;
}) => {
  const clearLabelPropagationSearchParams =
    useClearLabelPropagationSearchParams();
  const { closePanel, mode, showPreviousMode } = useDataPageRightPanelContext();

  const handleClick = () => {
    if (mode) {
      clearLabelPropagationSearchParams();
      closePanel();
    } else {
      showPreviousMode({ fallback: "summary" });
    }
  };
  return (
    <div
      className={classNames(styles.RightPanelToggleButton, className, {
        [styles.active]: mode === "summary",
      })}
      onClick={handleClick}
      data-testid="right-panel-toggle-button"
    >
      <RightPanelToggleIcon />
    </div>
  );
};
